// extracted by mini-css-extract-plugin
export default {"field":"Select_field__BrVAf","label":"Select_label__AOjYj","select":"Select_select__7QVBS"};